import { ReferentielModel } from './referentiel.model';
import { VideoContentModel } from './video-content.model';
import { AudioContentModel } from './audio-content.model';
import { SubtitleContentModel } from './subtitle-content.model';

export class ProgramModel {
  public id: number = null;
  public bonusType: ReferentielModel;
  public restoration: ReferentielModel = new ReferentielModel();
  public idWorkMilo: number = null;
  public idVersionMilo: number = null;
  public miloCode: string = null;
  public property: ReferentielModel = new ReferentielModel();
  public description: string = null;
  public note: string = null;
  public videoContents: VideoContentModel[] = [];
  public audioContents: AudioContentModel[] = [];
  public subtitleContents: SubtitleContentModel[] = [];
  public order = 0;

  constructor() {
    this.bonusType = new ReferentielModel();
    this.bonusType.id = 1;
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
